export default __webpack_public_path__ + "static/media/cStyleDelivering.cbd0e197.png";